<template>

    <div class="page">

        <top-header></top-header>

        <b-container fluid style="margin-top: 5%;">

            <b-row class="mt-3 mb-2">

                <b-col class="col-md-6 col-sm-6 col-xs-6">

                    <h3>Location: {{location}}</h3>

                </b-col>

                <b-col class="col-md-3 col-sm-6 col-xs-6 text-right">

                    <span v-if="device.group_id!=6">

                        <p v-if="$root.chkperm('page_devices','control')" class="p-1">                                              

                                <span v-if="firstRecord.output_status==1">

                                    <!-- ON: {{row.item.output_status}} -->

                                    <toggle-button  :value="true" :name="device.imei_no" @change="onChangeEventHandler(device.imei_no,$event)" :sync="true" :labels="{checked: 'Light ON', unchecked: 'Light OFF'}" :color="{checked: '#28a745', unchecked: '#dc3545'}" :width="80" :height="25" />

                                </span>

                                <span v-else >

                                    <!-- off:{{row.item.output_status}} -->

                                    <toggle-button :value="false" :name="device.imei_no" @change="onChangeEventHandler(device.imei_no,$event)" :sync="true" :labels="{checked: 'Light ON', unchecked: 'Light OFF'}" :color="{checked: '#28a745', unchecked: '#dc3545'}" :width="80" :height="20" />



                                </span>

                        </p>

                    </span>

                    <!-- <span v-else>

                        <p v-if="$root.chkperm('page_devices','control')" class="p-1">  

                            <toggle-button  :value="row.item.amp_r>0?true:false" :name="row.item.imei_no" @change="onChangeEventPhaseHandler(row.item.imei_no,'R',$event)" :sync="true" :labels="{checked: 'R Light ON', unchecked: 'R Light OFF'}" :color="{checked: '#28a745', unchecked: '#dc3545'}" :width="95" :height="25" />     



                            <toggle-button  :value="row.item.amp_y>0?true:false" :name="row.item.imei_no" @change="onChangeEventPhaseHandler(row.item.imei_no,'Y',$event)" :sync="true" :labels="{checked: 'Y Light ON', unchecked: 'Y Light OFF'}" :color="{checked: '#28a745', unchecked: '#dc3545'}" :width="95" :height="25" />



                            <toggle-button  :value="row.item.amp_b>0?true:false" :name="row.item.imei_no" @change="onChangeEventPhaseHandler(row.item.imei_no,'B',$event)" :sync="true" :labels="{checked: 'B Light ON', unchecked: 'B Light OFF'}" :color="{checked: '#28a745', unchecked: '#dc3545'}" :width="95" :height="25" />



                        </p>

                    </span> -->

                </b-col>

                <b-col class="col-md-3 col-sm-6 col-xs-6 text-right">

                    <!-- <b-button variant="dark" pill size="sm" class="mr-2"  @click="downloadPDF()">Download PDF</b-button> -->

                    <!-- <b-button variant="dark" pill size="sm"  @click="downloadcsv()">Download CSV</b-button> -->
					<b-button variant="dark" pill size="sm"  @click="downloadexcel()">Download xlsx</b-button>
					



                </b-col>

            </b-row>

        </b-container>

        <b-container fluid>

            <b-row>

                <b-col class="col-md-12 col-sm-12 col-xs-12">

                    <div style="border-top: 3px solid #333; border-radius: 5px; min-height: 100px; background-color: #FFF; display: flex; flex-direction: column;">

                        

                        <b-row class="mt-4 px-3 mb-3">

                            <b-col lg="3">

                                <label class="mr-2">Show</label>

                                <b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">

                                </b-form-select>

                                <span class="ml-2">entries</span>

                            </b-col>

							<b-col lg="6">
								<!-- <b-row class="align-items-end">
									<b-col>
										<b-form-group label="From Date" label-for="dateFrom" class="mb-2">
											<b-form-input
												id="dateFrom"
												v-model="dateFrom"
												type="date"
												:max="dateTo"
												size="sm"
												label-align-md="left"
												class="mb-0"	>
											</b-form-input>
										</b-form-group>
									</b-col>
									<b-col>
										<b-form-group label="To Date" label-for="dateTo" class="mb-2">
											<b-form-input
												id="dateTo"
												v-model="dateTo"
												type="date"
												:min="dateFrom"
												:max="todayDate"
												size="sm">
											</b-form-input>
										</b-form-group>
									</b-col>
									<b-col class="mb-2">
										<b-button
											variant="primary"
											size="sm"
											class="mt-4"
											@click="onDateRangeChange">
											<i class="fa fa-filter mr-1"></i> Apply Date Range
										</b-button>
									</b-col>
								</b-row> -->

								<b-row class="align-items-center">
										<b-col md="4">
											<b-form-group
												label="From"
												label-for="dateFrom"
												label-cols-md="4"
												content-cols-md="8"
												label-align-md="left"
												class="mb-0"
											>
												<b-form-input
													id="dateFrom"
													type="date"
													v-model="dateFrom"
												></b-form-input>
											</b-form-group>
										</b-col>

										<b-col md="4">
											<b-form-group
												label="To "
												label-for="dateTo"
												label-cols-md="4"
												content-cols-md="8"
												label-align-md="left"
												class="mb-0"
											>
												<b-form-input
													id="dateTo"
													type="date"
													v-model="dateTo"
												></b-form-input>
											</b-form-group>
										</b-col>

										<b-col md="4">
											<b-button variant="dark"  size="sm"
												
												@click="onDateRangeChange"
											>
												Apply Date Range
											</b-button>
										</b-col>
									</b-row>

							</b-col>

                            <b-col lg="3" >

                                <b-form-group label="Filter" label-cols-sm="3" label-align-sm="right" label-size="sm" label-for="filterInput" class="mb-0">

                                    <b-input-group size="sm">

                                        <b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search">

                                        </b-form-input>

                                        <b-input-group-append>

                                            <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>

                                        </b-input-group-append>

                                    </b-input-group>

                                </b-form-group>

                            </b-col>

                        </b-row>

                        <b-row class="px-3">

                            <b-col lg="12">

                                <b-table show-empty sticky-header small striped outlined stacked="md" :items="records" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :filterIncludedFields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered">

                                    <template v-slot:cell(output_status)="row">

                                        <b-badge pill variant="success" v-if="row.value == 1">ON</b-badge>

                                        <b-badge pill variant="danger" v-else>OFF</b-badge>

                                    </template>

                                    <template v-slot:cell(supply)="row">



                                        <img src="../assets/power-on.svg" v-if="row.value >0" style="max-width:20px; max-height:20px;">

                                        <img src="../assets/power-off.svg" v-else style="max-width:20px; max-height:20px;">

                                    </template>



                                    <template v-slot:cell(r_phase_mcv)="row">

                                                <b-list-group style="flex-direction:row;">

                                                    <b-list-group-item class="d-flex align-items-center m-0 p-0 border-0">

                                                        <span :class="row.item.r_phase_mcv==1 ? 'mcb_green' : 'mcb_red'" ></span>

                                                    </b-list-group-item>

                                                </b-list-group>                                             

                                            </template>

                                            <template v-slot:cell(y_phase_mcv)="row">

                                                <b-list-group style="flex-direction:row;">

                                                    <b-list-group-item class="d-flex align-items-center  m-0 p-0 border-0">

                                                        <span :class="row.item.y_phase_mcv==1 ? 'mcb_green' : 'mcb_red'" ></span> 

                                                    </b-list-group-item>

                                                </b-list-group>                                             

                                            </template>

                                            <template v-slot:cell(b_phase_mcv)="row">



                                                    <b-list-group-item class="d-flex align-items-center  m-0 p-0 border-0">

                                                        <span :class="row.item.b_phase_mcv==1 ? 'mcb_green' : 'mcb_red'" ></span> 

                                                    </b-list-group-item>



                                            </template>

                                    <template v-slot:cell(door_status)="row">

                                        <b-badge pill variant="danger" v-if="row.value == 1">OPENED</b-badge>

                                        <b-badge pill variant="success" v-else>CLOSED</b-badge>

                                    </template>



                                </b-table>

                            </b-col>

                        </b-row>

                        <b-row class="px-3 mb-3">

                            <b-col lg="6">

                                <span class="mr-2">Showing {{(currentPage-1)*perPage}} to {{currentPage*perPage}} of {{records.length}} entries</span>

                            </b-col>

                            <b-col lg="6">

                                <b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>

                            </b-col>

                        </b-row>

                    </div>

                </b-col>

            </b-row>

        </b-container>

		<transition name="fade">
				<b-row v-if="loading" class="loading" style="position: fixed; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);" align-v="center" align-h="center">
					<b-spinner label="Busy" variant="light"></b-spinner>
				</b-row>
			</transition>

    </div>

</template>

<script>

import Header from "@/components/Header.vue";
import { ToggleButton } from 'vue-js-toggle-button'
import * as XLSX from "xlsx-js-style";

export default {

    name: 'Devices Record',

    components: {

        "top-header": Header,

        ToggleButton



    },

    beforeDestroy(){
        window.removeEventListener("scroll", this.onScroll, true);

        if (this.pollTimer) {
            clearTimeout(this.pollTimer);
            this.pollTimer = null;
        }

        // Ignore any API response that is still pending when this page is closed.
        this.requestId++;
    },

    sockets: {

        connect() {

            this.is_connected = 'Connected';

            console.log('socket connected');

        },

        commtoser_res(data){

             data=JSON.parse(data);

            if(data.error==0){

                this.$bvToast.toast(data.message, {
                    title: 'Light status',
                    toaster: 'b-toaster-bottom-right', 
                    autoHideDelay: 5000,
                    variant: 'success',
                    solid: true,
                    appendToast: true
                });

            }else{
                this.$bvToast.toast(data.message, {
                    title: 'Light status',
                    toaster: 'b-toaster-bottom-right',
                    autoHideDelay: 5000,
                    variant: 'warning',
                    solid: true,
                    appendToast: true
                });

            }
            //alert(data);
        },
        disconnect() {
            this.is_connected = 'Disconnected';
            console.log('socket disconnected')
        },

        datarecieved(data){
            console.log('ye le data');
            console.log(JSON.stringify(data));
        },



    },

    mounted(){

        this.initload();

    },

    data() {
        var self = this;
        var today = self.$moment().format('YYYY-MM-DD');
        return{
			loading: true, 
            email: '',

            password: '',

            url: self.$session.get('apiurl')+'esmartapi/device-record-date',

            imeino: self.$route.params.imeino,

            location: '',

            records: [],

            device: {},

            firstRecord:[],
            user_id:0,

            // Date filter defaults to today.
            dateFrom: today,
            dateTo: today,
            todayDate: today,
            appliedDateFrom: today,
            appliedDateTo: today,

            // Used to manage automatic refresh and ignore stale API responses.
            pollTimer: null,
            requestId: 0,

            fields: [

                { key: 'supply', label: 'Power', sortable: true, sortDirection: 'desc'},

                { key: 'voltage_r', label: 'Volt.R',

                    formatter: (value) => { 

                        /*if(self.device.meter_type === '1P'){

                            return value;

                        }



                        if(parseInt(value/100) <= 80){

                            value = 0;

                        }*/

                        //alert(self.device.meter_type);

                        return parseFloat(value).toFixed(1);

                    },

                },

                { key: 'voltage_y', label: 'Volt.Y',

                    formatter: (value) => { 

                        /*if(self.device.meter_type === '1P'){

                            return '0.0';

                        }

                        if(parseInt(value/100) <= 80){

                            value = 0;

                        }*/

                        return parseFloat(value).toFixed(1);

                    },

                },



                { key: 'voltage_b', label: 'Volt.B',

                    formatter: (value) => {

                        /*if(self.device.meter_type === '1P'){

                            return '0.0';

                        } 

                        if(parseInt(value/100) <= 80){

                            value = 0;

                        }*/

                        return parseFloat(value).toFixed(1);

                    },

                },

                { key: 'amp_r', label: 'Amp.R',

                    formatter: (value, key, item) => { 



                        if(item.output_status == 0 && parseInt(value) < self.$root.correction_amp){

                            value = 0;

                        }                       

                        return parseFloat(value).toFixed(1);

                    },

                },

                { key: 'amp_y', label: 'Amp.Y',

                    formatter: (value, key, item) => { 

                        if(item.output_status == 0 && parseInt(value) < self.$root.correction_amp){

                            value = 0;

                        }

                        return parseFloat(value).toFixed(1);

                    },

                },

                { key: 'amp_b', label: 'Amp.B',

                    formatter: (value, key, item) => { 

                        if(item.output_status == 0 && parseInt(value) < self.$root.correction_amp){

                            value = 0;

                        }



                        return parseFloat(value).toFixed(1);

                    },

                },



                { key: 'pf_r', label: 'PF R',

                    formatter: (value) => { 

                        if(value==""){

                            value =0.00;

                        }

                        return parseFloat(value).toFixed(2);



                    }

                },

                { key: 'pf_y', label: 'PF Y',

                    formatter: (value) => { 



                        return parseFloat(value).toFixed(2);

                    }

                },

                { key: 'pf_b', label: 'PF B',

                    formatter: (value) => { 



                        return parseFloat(value).toFixed(2);

                    }

                },

                { key: 'kw_r', label: 'KwR',

                    formatter: (value, key, item) => { 

                        /*if(self.device.meter_type === '1P'){

                            return value;

                        }

*/

                        if(item.output_status == 0 && (parseInt(item.amp_r) < self.$root.correction_amp)){

                            value = 0;

                        }

                        if(parseInt(item.voltage_r) <= 80){

                            value = 0;

                        }

                        return parseFloat(value).toFixed(1);

                    },

                },

                { key: 'kw_y', label: 'KwY',

                    formatter: (value, key, item) => { 

                        if(item.output_status == 0 && (parseInt(item.amp_y) < self.$root.correction_amp)){

                            value = 0;

                        }

                        if(parseInt(item.voltage_y) <= 80){

                            value = 0;

                        }

                        return parseFloat(value).toFixed(1);

                    },

                },

                { key: 'kw_b', label: 'KwB',

                    formatter: (value, key, item) => { 

                        if(item.output_status == 0 && (parseInt(item.amp_b) < self.$root.correction_amp)){

                            value = 0;

                        }

                        if(parseInt(item.voltage_b) <= 80){

                            value = 0;

                        }

                        return parseFloat(value).toFixed(1);

                    },

                },

                { key: 'kwh', label: 'Kwh',

                    formatter: (value) => { 

                        return parseFloat(value).toFixed(1);

                    },

                },

                /* { key: 'frequency', label: 'Frequency'}, */

                { key: 'total_kw', label: 'Total KW',

                    formatter: (value, key, item) => { 



                        if(item.output_status == 0 && (parseInt(item.amp_r) < self.$root.correction_amp && parseInt(item.amp_y) < self.$root.correction_amp && parseInt(item.amp_b) < self.$root.correction_amp)){

                            value = 0;

                        }

                        return parseFloat(value).toFixed(1);

                    },

                },

                { key: 'total_kva', label: 'Total KVA',

                    formatter: (value) => { 



                        /* if(item.output_status == 0 && (parseInt(item.amp_r) < self.$root.correction_amp && parseInt(item.amp_y) < self.$root.correction_amp && parseInt(item.amp_b) < self.$root.correction_amp)){

                            value = 0;

                        } */

                        return parseFloat(value).toFixed(1);

                    },

                },              

                { key: 'meter_stamp', label: 'MeterLastStamp',

                    formatter: (value, key, item) => {

                        var self = this;

                        if(item.meter_stamp==null || item.meter_stamp=='null'){

                            return '---';

                        }else{

                            return self.$moment(item.meter_stamp).format('DD-MM-YYYY HH:mm:ss');

                        }



                    }, 

                },  

                { key: 'update_time', label: 'TimeStamp',

                    formatter: (value, key, item) => {

                        var self = this;

                        return self.$moment(item.update_time).format('DD-MM-YYYY HH:mm:ss');

                    }, 

                },          

                { key: 'output_status', label: 'Output', sortable: true },

                { key: 'r_phase_mcv', label: 'I/P MCB',thStyle:'min-width:65px;' }, 

                 { key: 'y_phase_mcv', label: 'O/P MCB',thStyle:'min-width:65px;'  }, 

                 { key: 'b_phase_mcv', label: 'Contactor Status',class:"text-center", thStyle:'min-width:125px;'}, 

                  { key: 'auto_manual', label: 'Control Mode',class:"text-center", thStyle:'min-width:125px;',formatter: (value) => {

                        var mode = 'Manual';



                        if(value==1){

                            mode = 'Auto';

                        } 

                        return mode;

                    },

                 }, 

                 { key: 'light_on', label: 'Light On', sortable: true },

                { key: 'light_off', label: 'Light Off', sortable: true }, 

                /* { key: 'light_data', label: 'Thread', sortable: true ,

                    formatter: (value) => {

                        //var self = this;

                        //console.log(key+'--'+item.update_time);

                        if(value!=null && value!='null'){

                            var lightData = JSON.parse(value);

                            return lightData.thread; //self.$moment(item.update_time).format('DD-MM-YYYY HH:mm:ss');

                        }else{

                            return 0;

                        }

                    }, 

                }, */

                { key: 'door_status', label: 'Door', sortable: true }

            ],

            totalRows: 1,

            currentPage: 1,

            pageOptions: [10, 20, 50, 100],

            perPage: 10,

            sortBy: '',

            sortDesc: false,

            sortDirection: 'asc',

            filter: null,

            filterOn: []

        };

    },

    methods: {

        onDateRangeChange() {
            var self = this;

            if (!self.dateFrom || !self.dateTo) {
                return;
            }

            var today = self.$moment().startOf('day');
            var fromDate = self.$moment(self.dateFrom, 'YYYY-MM-DD', true).startOf('day');
            var toDate = self.$moment(self.dateTo, 'YYYY-MM-DD', true).startOf('day');
            var minimumDate = today.clone().subtract(7, 'days');

            if (!fromDate.isValid() || !toDate.isValid()) {
                self.showDateError('Please select valid From Date and To Date.');
                self.resetDateRange();
                return;
            }

            if (fromDate.isAfter(toDate)) {
                self.showDateError('From Date cannot be greater than To Date.');
                self.resetDateRange();
                return;
            }

            if (toDate.isAfter(today)) {
                self.showDateError('Future dates are not allowed.');
                self.resetDateRange();
                return;
            }

            // The oldest permitted From Date is today minus 7 calendar days.
            if (fromDate.isBefore(minimumDate)) {
                self.showDateError(
                    'Selected date range is more than 7 days old. Please contact administrator.'
                );
                self.resetDateRange();
                return;
            }

            self.appliedDateFrom = self.dateFrom;
            self.appliedDateTo = self.dateTo;
            self.currentPage = 1;

            if (self.pollTimer) {
                clearTimeout(self.pollTimer);
                self.pollTimer = null;
            }

            self.initload();
        },

        showDateError(message) {
            this.$bvToast.toast(message, {
                title: 'Date Range Not Allowed',
                toaster: 'b-toaster-bottom-right',
                autoHideDelay: 6000,
                variant: 'warning',
                solid: true
            });
        },

        resetDateRange() {
            this.dateFrom = this.appliedDateFrom;
            this.dateTo = this.appliedDateTo;
        },

        initload(){
            var self = this;
			self.loading = true;
            var userinfo = self.$session.get('user_info');

            if (userinfo) {
                self.user_id = userinfo.user_id;
            }

            // Cancel a pending polling timer before starting another request.
            if (self.pollTimer) {
                clearTimeout(self.pollTimer);
                self.pollTimer = null;
            }

            // Only the latest request is allowed to update the table.
            var currentRequestId = ++self.requestId;

            self.axios.post(self.url, {
                accesskey: self.$session.get('access_key'),
                imeino: self.imeino,
                date_from: self.appliedDateFrom,
                date_to: self.appliedDateTo
            })
            .then(function (response) {
                if (currentRequestId !== self.requestId) {
                    return;
                }

                if (response.data.error == 0 || response.data.error == '0') {
                    var result = response.data.result || {};
                    var tmparr = result.records || [];

                    self.location = result.location || '';

                    var kwhPrevious = 0;
                    tmparr.forEach(function(field) {
                        if (field.meter_phase_type == 1) {
                            field.total_kva = field.kva_r;
                        }

                        // As required: carry forward the previous non-zero KWH value.
                        if (field.kwh > 0) {
                            kwhPrevious = field.kwh;
                        }

                        if (field.kwh == 0) {
                            field.kwh = kwhPrevious;
                        }
                    });

                    self.records = tmparr;
                    self.loading = false;
                    self.totalRows = self.records.length;
                    self.device = result.device || {};
                    self.location = self.location + ' | FP No:' + (self.device.feeder_pillar_no || '');
                    self.firstRecord = self.records[0] || {};

                    // Refresh the currently selected date range automatically.
                    self.pollTimer = setTimeout(function() {
                        self.pollTimer = null;
                        self.initload();
                    }, self.$root.reload_duration);
                } else {
                    self.$root.forceLogout(response.data.message);
                }
            })
            .catch(function (error) {
                if (currentRequestId !== self.requestId) {
                    return;
                }
                console.error('Device record API error:', error);
            });
        },
        onFiltered(filteredItems) {

            // Trigger pagination to update the number of buttons/pages due to filtering

            this.totalRows = filteredItems.length

            this.currentPage = 1

        },

        downloadcsv(){

            var self = this;

            var header = new Array()

            self.fields.forEach(function(item){

                if(!item.extra){

                    header.push(item.label);

                }

            });



            //var d = table.rows().data();

            var finalarr = new Array();

            finalarr.push(header);

            self.records.forEach(function(row){

                var dataarr = new Array();

                self.fields.forEach(function(field){

                    if(field.key != 'extra'){

                        var fieldData = row[field.key];

                        //console.log('field.keyfield.key'+field.key);

                        if(field.key =='light_data'){

                            var value = row[field.key];

                            var threadValue =0;

                            if(value!=null && value!='null'){

                                var lightData = JSON.parse(value);                          

                                threadValue =  lightData.thread; 

                            }

                            fieldData=threadValue;

                        }



                        if(field.key == 'output_status'){

                        if(fieldData ==1){

                            fieldData = "ON";

                        }else{

                            fieldData = "OFF";

                        }

                    }



                    if(field.key == 'door_status'){

                        if(fieldData ==1){

                            fieldData = "OPEN";

                        }else{

                            fieldData = "CLOSED";

                        }

                    }







                        dataarr.push(fieldData);

                    }





                });

                finalarr.push(dataarr);

            });



            let csvContent = "data:text/csv;charset=utf-8," 

            + finalarr.map(e => e.join(",")).join("\n");



            var encodedUri = encodeURI(csvContent);

            var link = document.createElement("a");

            link.setAttribute("href", encodedUri);

            link.setAttribute("download", "device_data_report.csv");

            document.body.appendChild(link); // Required for FF



            link.click();

        },
		
	downloadexcel() {
			var self = this;

			// Prepare Excel headers
			var header = [];

			self.fields.forEach(function (item) {
				if (!item.extra) {
					header.push(item.label);
				}
			});

			// Prepare FP No and Location title
			/* var fpNo =
				self.device && self.device.feeder_pillar_no
					? self.device.feeder_pillar_no
					: ''; */

			var location = self.location || '';

			var title = "  Location: " + location;

			var finalarr = [];

			// First row: Title
			finalarr.push([title]);

			// Second row: Headers
			finalarr.push(header);

			// Third row onwards: Device records
			self.records.forEach(function (row) {
				var dataarr = [];

				self.fields.forEach(function (field) {
					if (field.key != 'extra') {

						var fieldData = row[field.key];

						// Light Data
						if (field.key == 'light_data') {
							var threadValue = 0;

							if (
								fieldData != null &&
								fieldData != '' &&
								fieldData != 'null'
							) {
								try {
									var lightData = JSON.parse(fieldData);
									threadValue = lightData.thread || 0;
								} catch (e) {
									threadValue = 0;
								}
							}

							fieldData = threadValue;
						}

						// Output Status
						if (field.key == 'output_status') {
							fieldData = fieldData == 1 ? "ON" : "OFF";
						}

						// Door Status
						if (field.key == 'door_status') {
							fieldData = fieldData == 1 ? "OPEN" : "CLOSED";
						}

						dataarr.push(
							fieldData == null ? '' : fieldData
						);
					}
				});

				finalarr.push(dataarr);
			});

			// Create worksheet
			var worksheet = XLSX.utils.aoa_to_sheet(finalarr);

			var range = XLSX.utils.decode_range(worksheet['!ref']);

			// Merge first row across all columns
			worksheet['!merges'] = [
				{
					s: { r: 0, c: 0 },
					e: { r: 0, c: range.e.c }
				}
			];

			// Title style
			var titleStyle = {
				font: {
					bold: true,
					sz: 13,
					color: { rgb: "000000" }
				},
				alignment: {
					horizontal: "center",
					vertical: "center"
				},
				border: {
					bottom: {
						style: "thin",
						color: { rgb: "D9E1F2" }
					}
				}
			};

			// Header style
			var headerStyle = {
				font: {
					bold: true,
					color: { rgb: "FFFFFF" },
					sz: 11
				},
				fill: {
					fgColor: { rgb: "305496" }
				},
				alignment: {
					horizontal: "center",
					vertical: "center",
					wrapText: true
				},
				border: {
					top: { style: "thin", color: { rgb: "000000" } },
					bottom: { style: "thin", color: { rgb: "000000" } },
					left: { style: "thin", color: { rgb: "000000" } },
					right: { style: "thin", color: { rgb: "000000" } }
				}
			};

			// Data cell style
			var cellStyle = {
				alignment: {
					vertical: "center"
				},
				border: {
					top: { style: "thin", color: { rgb: "D9E1F2" } },
					bottom: { style: "thin", color: { rgb: "D9E1F2" } },
					left: { style: "thin", color: { rgb: "D9E1F2" } },
					right: { style: "thin", color: { rgb: "D9E1F2" } }
				}
			};

			// Apply cell styles
			for (var R = range.s.r; R <= range.e.r; R++) {
				for (var C = range.s.c; C <= range.e.c; C++) {

					var cellAddress = XLSX.utils.encode_cell({
						r: R,
						c: C
					});

					if (!worksheet[cellAddress]) continue;

					if (R === 0) {
						worksheet[cellAddress].s = titleStyle;
					} else if (R === 1) {
						worksheet[cellAddress].s = headerStyle;
					} else {
						worksheet[cellAddress].s = cellStyle;
					}
				}
			}

			// Row heights
			worksheet['!rows'] = [
				{ hpt: 30 },
				{ hpt: 30 }
			];

			// Auto-adjust column widths
			worksheet['!cols'] = header.map(function (column, index) {
				var maxLength = String(column).length;

				finalarr.forEach(function (row) {
					var value = row[index];

					if (value != null) {
						maxLength = Math.max(
							maxLength,
							String(value).length
						);
					}
				});

				return {
					wch: Math.min(Math.max(maxLength + 3, 12), 35)
				};
			});

			// Create workbook
			var workbook = XLSX.utils.book_new();

			XLSX.utils.book_append_sheet(
				workbook,
				worksheet,
				"Device Records"
			);

			// Download Excel file
			XLSX.writeFile(
				workbook,
				"device_data_report.xlsx"
			);
		},

		downloadexcel2() {
			var self = this;

			var header = [];

			// Prepare Excel headers
			self.fields.forEach(function (item) {
				if (!item.extra) {
					header.push(item.label);
				}
			});

			var finalarr = [];
			finalarr.push(header);

			// Prepare Excel rows
			self.records.forEach(function (row) {
				var dataarr = [];

				self.fields.forEach(function (field) {
					if (field.key != 'extra') {

						var fieldData = row[field.key];

						// Light Data
						if (field.key == 'light_data') {
							var threadValue = 0;

							if (
								fieldData != null &&
								fieldData != '' &&
								fieldData != 'null'
							) {
								try {
									var lightData = JSON.parse(fieldData);
									threadValue = lightData.thread || 0;
								} catch (e) {
									threadValue = 0;
								}
							}

							fieldData = threadValue;
						}

						// Output Status
						if (field.key == 'output_status') {
							fieldData = fieldData == 1 ? "ON" : "OFF";
						}

						// Door Status
						if (field.key == 'door_status') {
							fieldData = fieldData == 1 ? "OPEN" : "CLOSED";
						}

						dataarr.push(
							fieldData == null ? '' : fieldData
						);
					}
				});

				finalarr.push(dataarr);
			});

			// Create Excel worksheet
			var worksheet = XLSX.utils.aoa_to_sheet(finalarr);

			// Header styling
			var headerStyle = {
				font: {
					bold: true,
					color: { rgb: "FFFFFF" },
					sz: 11
				},
				fill: {
					fgColor: { rgb: "305496" }
				},
				alignment: {
					horizontal: "center",
					vertical: "center",
					wrapText: true
				},
				border: {
					top: { style: "thin", color: { rgb: "000000" } },
					bottom: { style: "thin", color: { rgb: "000000" } },
					left: { style: "thin", color: { rgb: "000000" } },
					right: { style: "thin", color: { rgb: "000000" } }
				}
			};

			// Data cell styling
			var cellStyle = {
				alignment: {
					vertical: "center"
				},
				border: {
					top: { style: "thin", color: { rgb: "D9E1F2" } },
					bottom: { style: "thin", color: { rgb: "D9E1F2" } },
					left: { style: "thin", color: { rgb: "D9E1F2" } },
					right: { style: "thin", color: { rgb: "D9E1F2" } }
				}
			};

			// Apply styling to all cells
			var range = XLSX.utils.decode_range(worksheet['!ref']);

			for (var R = range.s.r; R <= range.e.r; R++) {
				for (var C = range.s.c; C <= range.e.c; C++) {

					var cellAddress = XLSX.utils.encode_cell({
						r: R,
						c: C
					});

					if (!worksheet[cellAddress]) continue;

					worksheet[cellAddress].s =
						R === 0 ? headerStyle : cellStyle;
				}
			}

			// Header row height
			worksheet['!rows'] = [
				{ hpt: 25 }
			];

			// Automatically adjust column widths
			worksheet['!cols'] = header.map(function (column, index) {
				var maxLength = String(column).length;

				finalarr.forEach(function (row) {
					var value = row[index];

					if (value != null) {
						maxLength = Math.max(
							maxLength,
							String(value).length
						);
					}
				});

				return {
					wch: Math.min(Math.max(maxLength + 3, 12), 35)
				};
			});

			// Create workbook
			var workbook = XLSX.utils.book_new();

			XLSX.utils.book_append_sheet(
				workbook,
				worksheet,
				"Device Records"
			);

			// Download Excel file
			XLSX.writeFile(
				workbook,
				"device_data_report.xlsx"
			);
		},

        downloadPDF(){

            var self = this;



            var pdfMake = require('pdfmake/build/pdfmake.js');

            var pdfFonts = require('pdfmake/build/vfs_fonts.js');

            pdfMake.vfs = pdfFonts.pdfMake.vfs;



            var pdfdata = new Array();

            var data = new Array();

            //var headerlength = 0;

            self.fields.forEach(element => {

                data.push(element.label);

                //headerlength++;

            });



            //var count = headerlength;

            pdfdata.push(data); 

            for(var i=0; i<self.records.length; i++){

                data = new Array();



                /* var output_status = self.records[i]['output_status'];

                var amp_r = self.records[i]['amp_r'];

                var amp_y = self.records[i]['amp_y'];

                var amp_b = self.records[i]['amp_b'];

                var kw_r = self.records[i]['kw_r']; */

                self.fields.forEach(element => {

                    var value = self.records[i][element.key];



                    if(element.key == 'total_kw'){

                            value = (value/1).toFixed(3);

                        }





                        if(element.key =='light_data'){



                            var threadValue =0;

                            if(value!=null && value!='null'){

                                var lightData = JSON.parse(value);                          

                                threadValue =  lightData.thread; 

                            }

                            value=threadValue;

                        }



                    if(element.key == 'output_status'){

                        if(value ==1){

                            value = "ON";

                        }else{

                            value = "OFF";

                        }

                    }



                    if(element.key == 'door_status'){

                        if(value ==1){

                            value = "OPEN";

                        }else{

                            value = "CLOSED";

                        }

                    }







                    data.push(value);

                });

                pdfdata.push(data);

            }

            var deviceid = self.imeino





            var d = new Date();

            var uniq = d.getFullYear()+'-'+d.getMonth()+'-'+d.getDate()+'-'+d.getTime();





            var fontsize = 12;

            var page = "landscape";

            var pagesize = "A4";

            /* if (count < 10) {

                fontsize = 14;

                 page = "portrait";

                pagesize = "A4";

            } else if (count < 15) {

                 fontsize = 10;

                page = "portrait";

                 pagesize = "A4";

            } else if (count > 15) {

                 fontsize = 14;

                page = "landscape";

                pagesize = "A4";

            } */





            var docDefinition = {

                content: [

                    { text: 'Device Report : '+deviceid, style: 'heading' },

                    { text: ' ', style: 'heading' },

                    {

                        layout: 'lightHorizontalLines',

                        table: {

                            headerRows: 1,



                            body: pdfdata

                        }

                    }

                ],

                styles: {

                    heading: {

                        fontSize: 20,

                        alignment: 'center',

                        lineHeight: 1,

                        bold: true

                    },

                    subheading: {

                        fontSize: 14,

                        alignment: 'center',

                        lineHeight: 2,

                        bold: false

                    }

                }, 

                defaultStyle: {

                    fontSize: fontsize,

                    bold: false

                },

                //pageOrientation: 'landscape',

                pageSize: pagesize,

                pageOrientation: page

            };

            pdfMake.createPdf(docDefinition).download("REPORT_"+uniq+".pdf");

        },

        onChangeEventHandler(imei,event){

            let switchStatus = event.value;

            console.log('dev'+switchStatus);

            var o = new Object();

            var cmd ='ON';

            if(switchStatus==false){

                cmd = 'OFF';    

            }

            o.imei = imei;

            o.command = cmd;

            o.user_id = this.user_id;

            console.log('Send Cmd:'+JSON.stringify(o));         

            if(this.$socket.connected){

                console.log("CONNECTED AND LOADING DATA");



                this.$socket.emit('commtoser', o);

            }

            this.initload();

        },

        onChangeEventPhaseHandler(imei,phase,event){

            let switchStatus = event.value;

            console.log('dev'+switchStatus);

            var o = new Object();

            var cmd ='ON';

            if(switchStatus==false){

                cmd = 'OFF';    

            }

            o.imei  = imei; 

            o.phase = phase; 

            o.command = cmd;

            o.user_id = this.user_id;

            console.log('Send Cmd:'+JSON.stringify(o));

            console.log('asdasd');

            if(this.$socket.connected){

                console.log("CONNECTED AND LOADING DATA");



                this.$socket.emit('commtoser_phase', o);

            }

            this.initload();

        },

    }

}

</script>

<style>

html{

    min-height: 100%;

}

body{

    background-color: '#FFF' !important;

    background-image: none !important;

}

.table{

    font-size: small;

}

.table td, .table th{

    vertical-align: middle;

}

</style>